module.exports = __webpack_public_path__ + "media/images/history/stodulkova1-dfa80d32caf3143358dc4f776c905b76.jpg";